import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import type { Image } from "services/cms/models/image";
import type { SectionImageGallery } from "services/cms/models/sectionImageGallery";
import type { ResolvedImage } from "./imageResolver";
import imageResolver from "./imageResolver";

export interface ResolvedImageGallery {
    codename: string;
    images: ResolvedImage[];
    type: ContentTypeCodenames.SectionImageGallery;
}

const imageGalleryResolver = (data: SectionImageGallery): ResolvedImageGallery => {
    const images = data.elements.images.linkedItems as Image[];

    return {
        codename: data.system.codename,
        images: images.map(imageResolver),
        type: ContentTypeCodenames.SectionImageGallery,
    };
};

export default imageGalleryResolver;
